module.exports = __webpack_public_path__ + "img/number2.30c396bd.png";